package com.vamvisions.main.api.contact

import kotlinx.serialization.Serializable

/**
 * A message from the website's contact form. [topic] is what the message is about, when the visitor chose one.
 * [website] is the form's hidden honeypot field: people leave it empty, so a value marks an automated submission.
 */
@Serializable
data class ContactMessageRequestDto(
    val name: String? = null,
    val email: String,
    val message: String,
    val topic: ContactTopicDto? = null,
    val website: String? = null,
)

/** What a contact message is about. Any other value fails deserialization, so the server rejects it. */
@Serializable
enum class ContactTopicDto { APP_DEVELOPMENT, DIGITAL_PRODUCT, PARTNERSHIP, OTHER }

/** Body of the `202 Accepted` response to a contact message. */
@Serializable
data class ContactMessageAcceptedDto(
    val status: String = STATUS_ACCEPTED,
) {
    companion object {
        const val STATUS_ACCEPTED = "accepted"
    }
}
